module.exports = __webpack_public_path__ + "data/users.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/users/users.json
// module id = og9u
// module chunks = 1